module.exports = __webpack_public_path__ + "static/img/1-1Z6041346305A.ffe9fde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z6041346305A.jpg
// module id = ArrA
// module chunks = 0